import React from "react";
import MainLayout from "@/components/layout/MainLayout";
import { SuperAdminLayout } from "@/components/super-admin/SuperAdminLayout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { UserCog } from "lucide-react";

const UserManagementPage = () => {
    return (
        <MainLayout>
            <SuperAdminLayout
                title="User Management"
                description="Manage users across all organizations"
            >
                <Card>
                    <CardHeader>
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                                <UserCog className="h-6 w-6 text-primary" />
                            </div>
                            <div>
                                <CardTitle>User Management</CardTitle>
                                <CardDescription>View and manage all system users</CardDescription>
                            </div>
                        </div>
                    </CardHeader>
                    <CardContent>
                        <p className="text-center py-8 text-muted-foreground">
                            User management functionality coming soon.
                        </p>
                    </CardContent>
                </Card>
            </SuperAdminLayout>
        </MainLayout>
    );
};

export default UserManagementPage; 